module.exports = __webpack_public_path__ + "media/backgrounds/kabita-darlami-f_dFplZ6IaQ-unsplash-f0f93fee.jpg";